import React from 'react'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

type ErrorFallbackProps = {
  resetError(): void
}

export function ErrorFallback({
  resetError,
}: ErrorFallbackProps): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Box
      flexGrow={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Paper variant="outlined">
        <Box p={2}>
          <Typography variant="h5">{t('error.title')}</Typography>

          <Box mt={1} mb={1.5}>
            <Typography>{t('error.message')}</Typography>
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={resetError}
            fullWidth
          >
            {t('error.retry')}
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
